import { m as Et } from "./monaco-mOO7KHw4.js";
var Ct = Object.defineProperty, xt = Object.getOwnPropertyDescriptor, At = Object.getOwnPropertyNames, It = Object.prototype.hasOwnProperty, u = {};
((t, e, n, i) => {
  if (e && typeof e == "object" || typeof e == "function") for (let r of At(e)) It.call(t, r) || r === n || Ct(t, r, { get: () => e[r], enumerable: !(i = xt(e, r)) || i.enumerable });
})(u, Et, "default");
var ie, oe, U, ae, k, se, p, ue, q, ce, de, ge, Q, le, he, fe, pe, me, M, G, ve, _e, J, we, S, W, be, ke, ye, $, Ee, P, Ce, x, V, R, xe, v, C, H, X, Ae, F, Ie, L, Se, j, Re, te, St = class {
  constructor(t) {
    this._defaults = t, this._worker = null, this._client = null, this._idleCheckInterval = window.setInterval((() => this._checkIfIdle()), 3e4), this._lastUsedTime = 0, this._configChangeListener = this._defaults.onDidChange((() => this._stopWorker()));
  }
  _stopWorker() {
    this._worker && (this._worker.dispose(), this._worker = null), this._client = null;
  }
  dispose() {
    clearInterval(this._idleCheckInterval), this._configChangeListener.dispose(), this._stopWorker();
  }
  _checkIfIdle() {
    this._worker && Date.now() - this._lastUsedTime > 12e4 && this._stopWorker();
  }
  _getClient() {
    return this._lastUsedTime = Date.now(), this._client || (this._worker = u.editor.createWebWorker({ moduleId: "vs/language/css/cssWorker", label: this._defaults.languageId, createData: { options: this._defaults.options, languageId: this._defaults.languageId } }), this._client = this._worker.getProxy()), this._client;
  }
  getLanguageServiceWorker(...t) {
    let e;
    return this._getClient().then(((n) => {
      e = n;
    })).then(((n) => {
      if (this._worker) return this._worker.withSyncedResources(t);
    })).then(((n) => e));
  }
};
(oe = ie || (ie = {})).MIN_VALUE = -2147483648, oe.MAX_VALUE = 2147483647, (ae = U || (U = {})).MIN_VALUE = 0, ae.MAX_VALUE = 2147483647, (se = k || (k = {})).create = function(t, e) {
  return t === Number.MAX_VALUE && (t = U.MAX_VALUE), e === Number.MAX_VALUE && (e = U.MAX_VALUE), { line: t, character: e };
}, se.is = function(t) {
  var e = t;
  return a.objectLiteral(e) && a.uinteger(e.line) && a.uinteger(e.character);
}, (ue = p || (p = {})).create = function(t, e, n, i) {
  if (a.uinteger(t) && a.uinteger(e) && a.uinteger(n) && a.uinteger(i)) return { start: k.create(t, e), end: k.create(n, i) };
  if (k.is(t) && k.is(e)) return { start: t, end: e };
  throw new Error("Range#create called with invalid arguments[" + t + ", " + e + ", " + n + ", " + i + "]");
}, ue.is = function(t) {
  var e = t;
  return a.objectLiteral(e) && k.is(e.start) && k.is(e.end);
}, (ce = q || (q = {})).create = function(t, e) {
  return { uri: t, range: e };
}, ce.is = function(t) {
  var e = t;
  return a.defined(e) && p.is(e.range) && (a.string(e.uri) || a.undefined(e.uri));
}, (ge = de || (de = {})).create = function(t, e, n, i) {
  return { targetUri: t, targetRange: e, targetSelectionRange: n, originSelectionRange: i };
}, ge.is = function(t) {
  var e = t;
  return a.defined(e) && p.is(e.targetRange) && a.string(e.targetUri) && (p.is(e.targetSelectionRange) || a.undefined(e.targetSelectionRange)) && (p.is(e.originSelectionRange) || a.undefined(e.originSelectionRange));
}, (le = Q || (Q = {})).create = function(t, e, n, i) {
  return { red: t, green: e, blue: n, alpha: i };
}, le.is = function(t) {
  var e = t;
  return a.numberRange(e.red, 0, 1) && a.numberRange(e.green, 0, 1) && a.numberRange(e.blue, 0, 1) && a.numberRange(e.alpha, 0, 1);
}, (fe = he || (he = {})).create = function(t, e) {
  return { range: t, color: e };
}, fe.is = function(t) {
  var e = t;
  return p.is(e.range) && Q.is(e.color);
}, (me = pe || (pe = {})).create = function(t, e, n) {
  return { label: t, textEdit: e, additionalTextEdits: n };
}, me.is = function(t) {
  var e = t;
  return a.string(e.label) && (a.undefined(e.textEdit) || x.is(e)) && (a.undefined(e.additionalTextEdits) || a.typedArray(e.additionalTextEdits, x.is));
}, (G = M || (M = {})).Comment = "comment", G.Imports = "imports", G.Region = "region", (_e = ve || (ve = {})).create = function(t, e, n, i, r) {
  var o = { startLine: t, endLine: e };
  return a.defined(n) && (o.startCharacter = n), a.defined(i) && (o.endCharacter = i), a.defined(r) && (o.kind = r), o;
}, _e.is = function(t) {
  var e = t;
  return a.uinteger(e.startLine) && a.uinteger(e.startLine) && (a.undefined(e.startCharacter) || a.uinteger(e.startCharacter)) && (a.undefined(e.endCharacter) || a.uinteger(e.endCharacter)) && (a.undefined(e.kind) || a.string(e.kind));
}, (we = J || (J = {})).create = function(t, e) {
  return { location: t, message: e };
}, we.is = function(t) {
  var e = t;
  return a.defined(e) && q.is(e.location) && a.string(e.message);
}, (W = S || (S = {})).Error = 1, W.Warning = 2, W.Information = 3, W.Hint = 4, (ke = be || (be = {})).Unnecessary = 1, ke.Deprecated = 2, (ye || (ye = {})).is = function(t) {
  var e = t;
  return e != null && a.string(e.href);
}, (Ee = $ || ($ = {})).create = function(t, e, n, i, r, o) {
  var s = { range: t, message: e };
  return a.defined(n) && (s.severity = n), a.defined(i) && (s.code = i), a.defined(r) && (s.source = r), a.defined(o) && (s.relatedInformation = o), s;
}, Ee.is = function(t) {
  var e, n = t;
  return a.defined(n) && p.is(n.range) && a.string(n.message) && (a.number(n.severity) || a.undefined(n.severity)) && (a.integer(n.code) || a.string(n.code) || a.undefined(n.code)) && (a.undefined(n.codeDescription) || a.string((e = n.codeDescription) === null || e === void 0 ? void 0 : e.href)) && (a.string(n.source) || a.undefined(n.source)) && (a.undefined(n.relatedInformation) || a.typedArray(n.relatedInformation, J.is));
}, (Ce = P || (P = {})).create = function(t, e) {
  for (var n = [], i = 2; i < arguments.length; i++) n[i - 2] = arguments[i];
  var r = { title: t, command: e };
  return a.defined(n) && n.length > 0 && (r.arguments = n), r;
}, Ce.is = function(t) {
  var e = t;
  return a.defined(e) && a.string(e.title) && a.string(e.command);
}, (V = x || (x = {})).replace = function(t, e) {
  return { range: t, newText: e };
}, V.insert = function(t, e) {
  return { range: { start: t, end: t }, newText: e };
}, V.del = function(t) {
  return { range: t, newText: "" };
}, V.is = function(t) {
  var e = t;
  return a.objectLiteral(e) && a.string(e.newText) && p.is(e.range);
}, (xe = R || (R = {})).create = function(t, e, n) {
  var i = { label: t };
  return e !== void 0 && (i.needsConfirmation = e), n !== void 0 && (i.description = n), i;
}, xe.is = function(t) {
  var e = t;
  return e !== void 0 && a.objectLiteral(e) && a.string(e.label) && (a.boolean(e.needsConfirmation) || e.needsConfirmation === void 0) && (a.string(e.description) || e.description === void 0);
}, (v || (v = {})).is = function(t) {
  return typeof t == "string";
}, (H = C || (C = {})).replace = function(t, e, n) {
  return { range: t, newText: e, annotationId: n };
}, H.insert = function(t, e, n) {
  return { range: { start: t, end: t }, newText: e, annotationId: n };
}, H.del = function(t, e) {
  return { range: t, newText: "", annotationId: e };
}, H.is = function(t) {
  var e = t;
  return x.is(e) && (R.is(e.annotationId) || v.is(e.annotationId));
}, (Ae = X || (X = {})).create = function(t, e) {
  return { textDocument: t, edits: e };
}, Ae.is = function(t) {
  var e = t;
  return a.defined(e) && B.is(e.textDocument) && Array.isArray(e.edits);
}, (Ie = F || (F = {})).create = function(t, e, n) {
  var i = { kind: "create", uri: t };
  return e === void 0 || e.overwrite === void 0 && e.ignoreIfExists === void 0 || (i.options = e), n !== void 0 && (i.annotationId = n), i;
}, Ie.is = function(t) {
  var e = t;
  return e && e.kind === "create" && a.string(e.uri) && (e.options === void 0 || (e.options.overwrite === void 0 || a.boolean(e.options.overwrite)) && (e.options.ignoreIfExists === void 0 || a.boolean(e.options.ignoreIfExists))) && (e.annotationId === void 0 || v.is(e.annotationId));
}, (Se = L || (L = {})).create = function(t, e, n, i) {
  var r = { kind: "rename", oldUri: t, newUri: e };
  return n === void 0 || n.overwrite === void 0 && n.ignoreIfExists === void 0 || (r.options = n), i !== void 0 && (r.annotationId = i), r;
}, Se.is = function(t) {
  var e = t;
  return e && e.kind === "rename" && a.string(e.oldUri) && a.string(e.newUri) && (e.options === void 0 || (e.options.overwrite === void 0 || a.boolean(e.options.overwrite)) && (e.options.ignoreIfExists === void 0 || a.boolean(e.options.ignoreIfExists))) && (e.annotationId === void 0 || v.is(e.annotationId));
}, (Re = j || (j = {})).create = function(t, e, n) {
  var i = { kind: "delete", uri: t };
  return e === void 0 || e.recursive === void 0 && e.ignoreIfNotExists === void 0 || (i.options = e), n !== void 0 && (i.annotationId = n), i;
}, Re.is = function(t) {
  var e = t;
  return e && e.kind === "delete" && a.string(e.uri) && (e.options === void 0 || (e.options.recursive === void 0 || a.boolean(e.options.recursive)) && (e.options.ignoreIfNotExists === void 0 || a.boolean(e.options.ignoreIfNotExists))) && (e.annotationId === void 0 || v.is(e.annotationId));
}, (te || (te = {})).is = function(t) {
  var e = t;
  return e && (e.changes !== void 0 || e.documentChanges !== void 0) && (e.documentChanges === void 0 || e.documentChanges.every((function(n) {
    return a.string(n.kind) ? F.is(n) || L.is(n) || j.is(n) : X.is(n);
  })));
};
var Te, De, Me, Pe, B, Fe, Le, je, D, Oe, Y, h, l, ne, Ne, Ue, We, Ve, He, Ke, ze, Xe, K, Be, $e, qe, Qe, O, Z, Ge, f, g, Je, Ye, Ze, et, tt, E, nt, rt, it, ot, at, st, ut, ct, dt, gt, lt, ee, ht, z = (function() {
  function t(e, n) {
    this.edits = e, this.changeAnnotations = n;
  }
  return t.prototype.insert = function(e, n, i) {
    var r, o;
    if (i === void 0 ? r = x.insert(e, n) : v.is(i) ? (o = i, r = C.insert(e, n, i)) : (this.assertChangeAnnotations(this.changeAnnotations), o = this.changeAnnotations.manage(i), r = C.insert(e, n, o)), this.edits.push(r), o !== void 0) return o;
  }, t.prototype.replace = function(e, n, i) {
    var r, o;
    if (i === void 0 ? r = x.replace(e, n) : v.is(i) ? (o = i, r = C.replace(e, n, i)) : (this.assertChangeAnnotations(this.changeAnnotations), o = this.changeAnnotations.manage(i), r = C.replace(e, n, o)), this.edits.push(r), o !== void 0) return o;
  }, t.prototype.delete = function(e, n) {
    var i, r;
    if (n === void 0 ? i = x.del(e) : v.is(n) ? (r = n, i = C.del(e, n)) : (this.assertChangeAnnotations(this.changeAnnotations), r = this.changeAnnotations.manage(n), i = C.del(e, r)), this.edits.push(i), r !== void 0) return r;
  }, t.prototype.add = function(e) {
    this.edits.push(e);
  }, t.prototype.all = function() {
    return this.edits;
  }, t.prototype.clear = function() {
    this.edits.splice(0, this.edits.length);
  }, t.prototype.assertChangeAnnotations = function(e) {
    if (e === void 0) throw new Error("Text edit change is not configured to manage change annotations.");
  }, t;
})(), ft = (function() {
  function t(e) {
    this._annotations = e === void 0 ? /* @__PURE__ */ Object.create(null) : e, this._counter = 0, this._size = 0;
  }
  return t.prototype.all = function() {
    return this._annotations;
  }, Object.defineProperty(t.prototype, "size", { get: function() {
    return this._size;
  }, enumerable: !1, configurable: !0 }), t.prototype.manage = function(e, n) {
    var i;
    if (v.is(e) ? i = e : (i = this.nextId(), n = e), this._annotations[i] !== void 0) throw new Error("Id " + i + " is already in use.");
    if (n === void 0) throw new Error("No annotation provided for id " + i);
    return this._annotations[i] = n, this._size++, i;
  }, t.prototype.nextId = function() {
    return this._counter++, this._counter.toString();
  }, t;
})();
(function() {
  function t(e) {
    var n = this;
    this._textEditChanges = /* @__PURE__ */ Object.create(null), e !== void 0 ? (this._workspaceEdit = e, e.documentChanges ? (this._changeAnnotations = new ft(e.changeAnnotations), e.changeAnnotations = this._changeAnnotations.all(), e.documentChanges.forEach((function(i) {
      if (X.is(i)) {
        var r = new z(i.edits, n._changeAnnotations);
        n._textEditChanges[i.textDocument.uri] = r;
      }
    }))) : e.changes && Object.keys(e.changes).forEach((function(i) {
      var r = new z(e.changes[i]);
      n._textEditChanges[i] = r;
    }))) : this._workspaceEdit = {};
  }
  Object.defineProperty(t.prototype, "edit", { get: function() {
    return this.initDocumentChanges(), this._changeAnnotations !== void 0 && (this._changeAnnotations.size === 0 ? this._workspaceEdit.changeAnnotations = void 0 : this._workspaceEdit.changeAnnotations = this._changeAnnotations.all()), this._workspaceEdit;
  }, enumerable: !1, configurable: !0 }), t.prototype.getTextEditChange = function(e) {
    if (B.is(e)) {
      if (this.initDocumentChanges(), this._workspaceEdit.documentChanges === void 0) throw new Error("Workspace edit is not configured for document changes.");
      var n = { uri: e.uri, version: e.version };
      if (!(r = this._textEditChanges[n.uri])) {
        var i = { textDocument: n, edits: o = [] };
        this._workspaceEdit.documentChanges.push(i), r = new z(o, this._changeAnnotations), this._textEditChanges[n.uri] = r;
      }
      return r;
    }
    if (this.initChanges(), this._workspaceEdit.changes === void 0) throw new Error("Workspace edit is not configured for normal text edit changes.");
    var r;
    if (!(r = this._textEditChanges[e])) {
      var o = [];
      this._workspaceEdit.changes[e] = o, r = new z(o), this._textEditChanges[e] = r;
    }
    return r;
  }, t.prototype.initDocumentChanges = function() {
    this._workspaceEdit.documentChanges === void 0 && this._workspaceEdit.changes === void 0 && (this._changeAnnotations = new ft(), this._workspaceEdit.documentChanges = [], this._workspaceEdit.changeAnnotations = this._changeAnnotations.all());
  }, t.prototype.initChanges = function() {
    this._workspaceEdit.documentChanges === void 0 && this._workspaceEdit.changes === void 0 && (this._workspaceEdit.changes = /* @__PURE__ */ Object.create(null));
  }, t.prototype.createFile = function(e, n, i) {
    if (this.initDocumentChanges(), this._workspaceEdit.documentChanges === void 0) throw new Error("Workspace edit is not configured for document changes.");
    var r, o, s;
    if (R.is(n) || v.is(n) ? r = n : i = n, r === void 0 ? o = F.create(e, i) : (s = v.is(r) ? r : this._changeAnnotations.manage(r), o = F.create(e, i, s)), this._workspaceEdit.documentChanges.push(o), s !== void 0) return s;
  }, t.prototype.renameFile = function(e, n, i, r) {
    if (this.initDocumentChanges(), this._workspaceEdit.documentChanges === void 0) throw new Error("Workspace edit is not configured for document changes.");
    var o, s, c;
    if (R.is(i) || v.is(i) ? o = i : r = i, o === void 0 ? s = L.create(e, n, r) : (c = v.is(o) ? o : this._changeAnnotations.manage(o), s = L.create(e, n, r, c)), this._workspaceEdit.documentChanges.push(s), c !== void 0) return c;
  }, t.prototype.deleteFile = function(e, n, i) {
    if (this.initDocumentChanges(), this._workspaceEdit.documentChanges === void 0) throw new Error("Workspace edit is not configured for document changes.");
    var r, o, s;
    if (R.is(n) || v.is(n) ? r = n : i = n, r === void 0 ? o = j.create(e, i) : (s = v.is(r) ? r : this._changeAnnotations.manage(r), o = j.create(e, i, s)), this._workspaceEdit.documentChanges.push(o), s !== void 0) return s;
  };
})(), (De = Te || (Te = {})).create = function(t) {
  return { uri: t };
}, De.is = function(t) {
  var e = t;
  return a.defined(e) && a.string(e.uri);
}, (Pe = Me || (Me = {})).create = function(t, e) {
  return { uri: t, version: e };
}, Pe.is = function(t) {
  var e = t;
  return a.defined(e) && a.string(e.uri) && a.integer(e.version);
}, (Fe = B || (B = {})).create = function(t, e) {
  return { uri: t, version: e };
}, Fe.is = function(t) {
  var e = t;
  return a.defined(e) && a.string(e.uri) && (e.version === null || a.integer(e.version));
}, (je = Le || (Le = {})).create = function(t, e, n, i) {
  return { uri: t, languageId: e, version: n, text: i };
}, je.is = function(t) {
  var e = t;
  return a.defined(e) && a.string(e.uri) && a.string(e.languageId) && a.integer(e.version) && a.string(e.text);
}, (Oe = D || (D = {})).PlainText = "plaintext", Oe.Markdown = "markdown", (function(t) {
  t.is = function(e) {
    var n = e;
    return n === t.PlainText || n === t.Markdown;
  };
})(D || (D = {})), (Y || (Y = {})).is = function(t) {
  var e = t;
  return a.objectLiteral(t) && D.is(e.kind) && a.string(e.value);
}, (l = h || (h = {})).Text = 1, l.Method = 2, l.Function = 3, l.Constructor = 4, l.Field = 5, l.Variable = 6, l.Class = 7, l.Interface = 8, l.Module = 9, l.Property = 10, l.Unit = 11, l.Value = 12, l.Enum = 13, l.Keyword = 14, l.Snippet = 15, l.Color = 16, l.File = 17, l.Reference = 18, l.Folder = 19, l.EnumMember = 20, l.Constant = 21, l.Struct = 22, l.Event = 23, l.Operator = 24, l.TypeParameter = 25, (Ne = ne || (ne = {})).PlainText = 1, Ne.Snippet = 2, (Ue || (Ue = {})).Deprecated = 1, (Ve = We || (We = {})).create = function(t, e, n) {
  return { newText: t, insert: e, replace: n };
}, Ve.is = function(t) {
  var e = t;
  return e && a.string(e.newText) && p.is(e.insert) && p.is(e.replace);
}, (Ke = He || (He = {})).asIs = 1, Ke.adjustIndentation = 2, (ze || (ze = {})).create = function(t) {
  return { label: t };
}, (Xe || (Xe = {})).create = function(t, e) {
  return { items: t || [], isIncomplete: !!e };
}, (Be = K || (K = {})).fromPlainText = function(t) {
  return t.replace(/[\\`*_{}[\]()#+\-.!]/g, "\\$&");
}, Be.is = function(t) {
  var e = t;
  return a.string(e) || a.objectLiteral(e) && a.string(e.language) && a.string(e.value);
}, ($e || ($e = {})).is = function(t) {
  var e = t;
  return !!e && a.objectLiteral(e) && (Y.is(e.contents) || K.is(e.contents) || a.typedArray(e.contents, K.is)) && (t.range === void 0 || p.is(t.range));
}, (qe || (qe = {})).create = function(t, e) {
  return e ? { label: t, documentation: e } : { label: t };
}, (Qe || (Qe = {})).create = function(t, e) {
  for (var n = [], i = 2; i < arguments.length; i++) n[i - 2] = arguments[i];
  var r = { label: t };
  return a.defined(e) && (r.documentation = e), a.defined(n) ? r.parameters = n : r.parameters = [], r;
}, (Z = O || (O = {})).Text = 1, Z.Read = 2, Z.Write = 3, (Ge || (Ge = {})).create = function(t, e) {
  var n = { range: t };
  return a.number(e) && (n.kind = e), n;
}, (g = f || (f = {})).File = 1, g.Module = 2, g.Namespace = 3, g.Package = 4, g.Class = 5, g.Method = 6, g.Property = 7, g.Field = 8, g.Constructor = 9, g.Enum = 10, g.Interface = 11, g.Function = 12, g.Variable = 13, g.Constant = 14, g.String = 15, g.Number = 16, g.Boolean = 17, g.Array = 18, g.Object = 19, g.Key = 20, g.Null = 21, g.EnumMember = 22, g.Struct = 23, g.Event = 24, g.Operator = 25, g.TypeParameter = 26, (Je || (Je = {})).Deprecated = 1, (Ye || (Ye = {})).create = function(t, e, n, i, r) {
  var o = { name: t, kind: e, location: { uri: i, range: n } };
  return r && (o.containerName = r), o;
}, (et = Ze || (Ze = {})).create = function(t, e, n, i, r, o) {
  var s = { name: t, detail: e, kind: n, range: i, selectionRange: r };
  return o !== void 0 && (s.children = o), s;
}, et.is = function(t) {
  var e = t;
  return e && a.string(e.name) && a.number(e.kind) && p.is(e.range) && p.is(e.selectionRange) && (e.detail === void 0 || a.string(e.detail)) && (e.deprecated === void 0 || a.boolean(e.deprecated)) && (e.children === void 0 || Array.isArray(e.children)) && (e.tags === void 0 || Array.isArray(e.tags));
}, (E = tt || (tt = {})).Empty = "", E.QuickFix = "quickfix", E.Refactor = "refactor", E.RefactorExtract = "refactor.extract", E.RefactorInline = "refactor.inline", E.RefactorRewrite = "refactor.rewrite", E.Source = "source", E.SourceOrganizeImports = "source.organizeImports", E.SourceFixAll = "source.fixAll", (rt = nt || (nt = {})).create = function(t, e) {
  var n = { diagnostics: t };
  return e != null && (n.only = e), n;
}, rt.is = function(t) {
  var e = t;
  return a.defined(e) && a.typedArray(e.diagnostics, $.is) && (e.only === void 0 || a.typedArray(e.only, a.string));
}, (ot = it || (it = {})).create = function(t, e, n) {
  var i = { title: t }, r = !0;
  return typeof e == "string" ? (r = !1, i.kind = e) : P.is(e) ? i.command = e : i.edit = e, r && n !== void 0 && (i.kind = n), i;
}, ot.is = function(t) {
  var e = t;
  return e && a.string(e.title) && (e.diagnostics === void 0 || a.typedArray(e.diagnostics, $.is)) && (e.kind === void 0 || a.string(e.kind)) && (e.edit !== void 0 || e.command !== void 0) && (e.command === void 0 || P.is(e.command)) && (e.isPreferred === void 0 || a.boolean(e.isPreferred)) && (e.edit === void 0 || te.is(e.edit));
}, (st = at || (at = {})).create = function(t, e) {
  var n = { range: t };
  return a.defined(e) && (n.data = e), n;
}, st.is = function(t) {
  var e = t;
  return a.defined(e) && p.is(e.range) && (a.undefined(e.command) || P.is(e.command));
}, (ct = ut || (ut = {})).create = function(t, e) {
  return { tabSize: t, insertSpaces: e };
}, ct.is = function(t) {
  var e = t;
  return a.defined(e) && a.uinteger(e.tabSize) && a.boolean(e.insertSpaces);
}, (gt = dt || (dt = {})).create = function(t, e, n) {
  return { range: t, target: e, data: n };
}, gt.is = function(t) {
  var e = t;
  return a.defined(e) && p.is(e.range) && (a.undefined(e.target) || a.string(e.target));
}, (ee = lt || (lt = {})).create = function(t, e) {
  return { range: t, parent: e };
}, ee.is = function(t) {
  var e = t;
  return e !== void 0 && p.is(e.range) && (e.parent === void 0 || ee.is(e.parent));
}, (function(t) {
  function e(n, i) {
    if (n.length <= 1) return n;
    var r = n.length / 2 | 0, o = n.slice(0, r), s = n.slice(r);
    e(o, i), e(s, i);
    for (var c = 0, m = 0, d = 0; c < o.length && m < s.length; ) {
      var w = i(o[c], s[m]);
      n[d++] = w <= 0 ? o[c++] : s[m++];
    }
    for (; c < o.length; ) n[d++] = o[c++];
    for (; m < s.length; ) n[d++] = s[m++];
    return n;
  }
  t.create = function(n, i, r, o) {
    return new Rt(n, i, r, o);
  }, t.is = function(n) {
    var i = n;
    return !!(a.defined(i) && a.string(i.uri) && (a.undefined(i.languageId) || a.string(i.languageId)) && a.uinteger(i.lineCount) && a.func(i.getText) && a.func(i.positionAt) && a.func(i.offsetAt));
  }, t.applyEdits = function(n, i) {
    for (var r = n.getText(), o = e(i, (function(y, T) {
      var re = y.range.start.line - T.range.start.line;
      return re === 0 ? y.range.start.character - T.range.start.character : re;
    })), s = r.length, c = o.length - 1; c >= 0; c--) {
      var m = o[c], d = n.offsetAt(m.range.start), w = n.offsetAt(m.range.end);
      if (!(w <= s)) throw new Error("Overlapping edit");
      r = r.substring(0, d) + m.newText + r.substring(w, r.length), s = d;
    }
    return r;
  };
})(ht || (ht = {}));
var a, b, A, Rt = (function() {
  function t(e, n, i, r) {
    this._uri = e, this._languageId = n, this._version = i, this._content = r, this._lineOffsets = void 0;
  }
  return Object.defineProperty(t.prototype, "uri", { get: function() {
    return this._uri;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "languageId", { get: function() {
    return this._languageId;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(t.prototype, "version", { get: function() {
    return this._version;
  }, enumerable: !1, configurable: !0 }), t.prototype.getText = function(e) {
    if (e) {
      var n = this.offsetAt(e.start), i = this.offsetAt(e.end);
      return this._content.substring(n, i);
    }
    return this._content;
  }, t.prototype.update = function(e, n) {
    this._content = e.text, this._version = n, this._lineOffsets = void 0;
  }, t.prototype.getLineOffsets = function() {
    if (this._lineOffsets === void 0) {
      for (var e = [], n = this._content, i = !0, r = 0; r < n.length; r++) {
        i && (e.push(r), i = !1);
        var o = n.charAt(r);
        i = o === "\r" || o === `
`, o === "\r" && r + 1 < n.length && n.charAt(r + 1) === `
` && r++;
      }
      i && n.length > 0 && e.push(n.length), this._lineOffsets = e;
    }
    return this._lineOffsets;
  }, t.prototype.positionAt = function(e) {
    e = Math.max(Math.min(e, this._content.length), 0);
    var n = this.getLineOffsets(), i = 0, r = n.length;
    if (r === 0) return k.create(0, e);
    for (; i < r; ) {
      var o = Math.floor((i + r) / 2);
      n[o] > e ? r = o : i = o + 1;
    }
    var s = i - 1;
    return k.create(s, e - n[s]);
  }, t.prototype.offsetAt = function(e) {
    var n = this.getLineOffsets();
    if (e.line >= n.length) return this._content.length;
    if (e.line < 0) return 0;
    var i = n[e.line], r = e.line + 1 < n.length ? n[e.line + 1] : this._content.length;
    return Math.max(Math.min(i + e.character, r), i);
  }, Object.defineProperty(t.prototype, "lineCount", { get: function() {
    return this.getLineOffsets().length;
  }, enumerable: !1, configurable: !0 }), t;
})();
b = a || (a = {}), A = Object.prototype.toString, b.defined = function(t) {
  return t !== void 0;
}, b.undefined = function(t) {
  return t === void 0;
}, b.boolean = function(t) {
  return t === !0 || t === !1;
}, b.string = function(t) {
  return A.call(t) === "[object String]";
}, b.number = function(t) {
  return A.call(t) === "[object Number]";
}, b.numberRange = function(t, e, n) {
  return A.call(t) === "[object Number]" && e <= t && t <= n;
}, b.integer = function(t) {
  return A.call(t) === "[object Number]" && -2147483648 <= t && t <= 2147483647;
}, b.uinteger = function(t) {
  return A.call(t) === "[object Number]" && 0 <= t && t <= 2147483647;
}, b.func = function(t) {
  return A.call(t) === "[object Function]";
}, b.objectLiteral = function(t) {
  return t !== null && typeof t == "object";
}, b.typedArray = function(t, e) {
  return Array.isArray(t) && t.every(e);
};
var Tt = class {
  constructor(t, e, n) {
    this._languageId = t, this._worker = e, this._disposables = [], this._listener = /* @__PURE__ */ Object.create(null);
    const i = (o) => {
      let s, c = o.getLanguageId();
      c === this._languageId && (this._listener[o.uri.toString()] = o.onDidChangeContent((() => {
        window.clearTimeout(s), s = window.setTimeout((() => this._doValidate(o.uri, c)), 500);
      })), this._doValidate(o.uri, c));
    }, r = (o) => {
      u.editor.setModelMarkers(o, this._languageId, []);
      let s = o.uri.toString(), c = this._listener[s];
      c && (c.dispose(), delete this._listener[s]);
    };
    this._disposables.push(u.editor.onDidCreateModel(i)), this._disposables.push(u.editor.onWillDisposeModel(r)), this._disposables.push(u.editor.onDidChangeModelLanguage(((o) => {
      r(o.model), i(o.model);
    }))), this._disposables.push(n(((o) => {
      u.editor.getModels().forEach(((s) => {
        s.getLanguageId() === this._languageId && (r(s), i(s));
      }));
    }))), this._disposables.push({ dispose: () => {
      u.editor.getModels().forEach(r);
      for (let o in this._listener) this._listener[o].dispose();
    } }), u.editor.getModels().forEach(i);
  }
  dispose() {
    this._disposables.forEach(((t) => t && t.dispose())), this._disposables.length = 0;
  }
  _doValidate(t, e) {
    this._worker(t).then(((n) => n.doValidation(t.toString()))).then(((n) => {
      const i = n.map(((o) => (function(s, c) {
        let m = typeof c.code == "number" ? String(c.code) : c.code;
        return { severity: Dt(c.severity), startLineNumber: c.range.start.line + 1, startColumn: c.range.start.character + 1, endLineNumber: c.range.end.line + 1, endColumn: c.range.end.character + 1, message: c.message, code: m, source: c.source };
      })(0, o)));
      let r = u.editor.getModel(t);
      r && r.getLanguageId() === e && u.editor.setModelMarkers(r, e, i);
    })).then(void 0, ((n) => {
      console.error(n);
    }));
  }
};
function Dt(t) {
  switch (t) {
    case S.Error:
      return u.MarkerSeverity.Error;
    case S.Warning:
      return u.MarkerSeverity.Warning;
    case S.Information:
      return u.MarkerSeverity.Info;
    case S.Hint:
      return u.MarkerSeverity.Hint;
    default:
      return u.MarkerSeverity.Info;
  }
}
var Mt = class {
  constructor(t, e) {
    this._worker = t, this._triggerCharacters = e;
  }
  get triggerCharacters() {
    return this._triggerCharacters;
  }
  provideCompletionItems(t, e, n, i) {
    const r = t.uri;
    return this._worker(r).then(((o) => o.doComplete(r.toString(), I(e)))).then(((o) => {
      if (!o) return;
      const s = t.getWordUntilPosition(e), c = new u.Range(e.lineNumber, s.startColumn, e.lineNumber, s.endColumn), m = o.items.map(((d) => {
        const w = { label: d.label, insertText: d.insertText || d.label, sortText: d.sortText, filterText: d.filterText, documentation: d.documentation, detail: d.detail, command: (y = d.command, y && y.command === "editor.action.triggerSuggest" ? { id: y.command, title: y.title, arguments: y.arguments } : void 0), range: c, kind: Pt(d.kind) };
        var y, T;
        return d.textEdit && ((T = d.textEdit).insert !== void 0 && T.replace !== void 0 ? w.range = { insert: _(d.textEdit.insert), replace: _(d.textEdit.replace) } : w.range = _(d.textEdit.range), w.insertText = d.textEdit.newText), d.additionalTextEdits && (w.additionalTextEdits = d.additionalTextEdits.map(N)), d.insertTextFormat === ne.Snippet && (w.insertTextRules = u.languages.CompletionItemInsertTextRule.InsertAsSnippet), w;
      }));
      return { isIncomplete: o.isIncomplete, suggestions: m };
    }));
  }
};
function I(t) {
  if (t) return { character: t.column - 1, line: t.lineNumber - 1 };
}
function vt(t) {
  if (t) return { start: { line: t.startLineNumber - 1, character: t.startColumn - 1 }, end: { line: t.endLineNumber - 1, character: t.endColumn - 1 } };
}
function _(t) {
  if (t) return new u.Range(t.start.line + 1, t.start.character + 1, t.end.line + 1, t.end.character + 1);
}
function Pt(t) {
  const e = u.languages.CompletionItemKind;
  switch (t) {
    case h.Text:
      return e.Text;
    case h.Method:
      return e.Method;
    case h.Function:
      return e.Function;
    case h.Constructor:
      return e.Constructor;
    case h.Field:
      return e.Field;
    case h.Variable:
      return e.Variable;
    case h.Class:
      return e.Class;
    case h.Interface:
      return e.Interface;
    case h.Module:
      return e.Module;
    case h.Property:
      return e.Property;
    case h.Unit:
      return e.Unit;
    case h.Value:
      return e.Value;
    case h.Enum:
      return e.Enum;
    case h.Keyword:
      return e.Keyword;
    case h.Snippet:
      return e.Snippet;
    case h.Color:
      return e.Color;
    case h.File:
      return e.File;
    case h.Reference:
      return e.Reference;
  }
  return e.Property;
}
function N(t) {
  if (t) return { range: _(t.range), text: t.newText };
}
var Ft = class {
  constructor(t) {
    this._worker = t;
  }
  provideHover(t, e, n) {
    let i = t.uri;
    return this._worker(i).then(((r) => r.doHover(i.toString(), I(e)))).then(((r) => {
      if (r) return { range: _(r.range), contents: Lt(r.contents) };
    }));
  }
};
function pt(t) {
  return typeof t == "string" ? { value: t } : (e = t) && typeof e == "object" && typeof e.kind == "string" ? t.kind === "plaintext" ? { value: t.value.replace(/[\\`*_{}[\]()#+\-.!]/g, "\\$&") } : { value: t.value } : { value: "```" + t.language + `
` + t.value + "\n```\n" };
  var e;
}
function Lt(t) {
  if (t) return Array.isArray(t) ? t.map(pt) : [pt(t)];
}
var jt = class {
  constructor(t) {
    this._worker = t;
  }
  provideDocumentHighlights(t, e, n) {
    const i = t.uri;
    return this._worker(i).then(((r) => r.findDocumentHighlights(i.toString(), I(e)))).then(((r) => {
      if (r) return r.map(((o) => ({ range: _(o.range), kind: Ot(o.kind) })));
    }));
  }
};
function Ot(t) {
  switch (t) {
    case O.Read:
      return u.languages.DocumentHighlightKind.Read;
    case O.Write:
      return u.languages.DocumentHighlightKind.Write;
    case O.Text:
      return u.languages.DocumentHighlightKind.Text;
  }
  return u.languages.DocumentHighlightKind.Text;
}
var Nt = class {
  constructor(t) {
    this._worker = t;
  }
  provideDefinition(t, e, n) {
    const i = t.uri;
    return this._worker(i).then(((r) => r.findDefinition(i.toString(), I(e)))).then(((r) => {
      if (r) return [_t(r)];
    }));
  }
};
function _t(t) {
  return { uri: u.Uri.parse(t.uri), range: _(t.range) };
}
var Ut = class {
  constructor(t) {
    this._worker = t;
  }
  provideReferences(t, e, n, i) {
    const r = t.uri;
    return this._worker(r).then(((o) => o.findReferences(r.toString(), I(e)))).then(((o) => {
      if (o) return o.map(_t);
    }));
  }
}, Wt = class {
  constructor(t) {
    this._worker = t;
  }
  provideRenameEdits(t, e, n, i) {
    const r = t.uri;
    return this._worker(r).then(((o) => o.doRename(r.toString(), I(e), n))).then(((o) => (function(s) {
      if (!s || !s.changes) return;
      let c = [];
      for (let m in s.changes) {
        const d = u.Uri.parse(m);
        for (let w of s.changes[m]) c.push({ resource: d, versionId: void 0, textEdit: { range: _(w.range), text: w.newText } });
      }
      return { edits: c };
    })(o)));
  }
}, Vt = class {
  constructor(t) {
    this._worker = t;
  }
  provideDocumentSymbols(t, e) {
    const n = t.uri;
    return this._worker(n).then(((i) => i.findDocumentSymbols(n.toString()))).then(((i) => {
      if (i) return i.map(((r) => "children" in r ? wt(r) : { name: r.name, detail: "", containerName: r.containerName, kind: bt(r.kind), range: _(r.location.range), selectionRange: _(r.location.range), tags: [] }));
    }));
  }
};
function wt(t) {
  return { name: t.name, detail: t.detail ?? "", kind: bt(t.kind), range: _(t.range), selectionRange: _(t.selectionRange), tags: t.tags ?? [], children: (t.children ?? []).map(((e) => wt(e))) };
}
function bt(t) {
  let e = u.languages.SymbolKind;
  switch (t) {
    case f.File:
      return e.File;
    case f.Module:
      return e.Module;
    case f.Namespace:
      return e.Namespace;
    case f.Package:
      return e.Package;
    case f.Class:
      return e.Class;
    case f.Method:
      return e.Method;
    case f.Property:
      return e.Property;
    case f.Field:
      return e.Field;
    case f.Constructor:
      return e.Constructor;
    case f.Enum:
      return e.Enum;
    case f.Interface:
      return e.Interface;
    case f.Function:
      return e.Function;
    case f.Variable:
      return e.Variable;
    case f.Constant:
      return e.Constant;
    case f.String:
      return e.String;
    case f.Number:
      return e.Number;
    case f.Boolean:
      return e.Boolean;
    case f.Array:
      return e.Array;
  }
  return e.Function;
}
var qt = class {
  constructor(t) {
    this._worker = t;
  }
  provideLinks(t, e) {
    const n = t.uri;
    return this._worker(n).then(((i) => i.findDocumentLinks(n.toString()))).then(((i) => {
      if (i) return { links: i.map(((r) => ({ range: _(r.range), url: r.target }))) };
    }));
  }
}, Ht = class {
  constructor(t) {
    this._worker = t;
  }
  provideDocumentFormattingEdits(t, e, n) {
    const i = t.uri;
    return this._worker(i).then(((r) => r.format(i.toString(), null, kt(e)).then(((o) => {
      if (o && o.length !== 0) return o.map(N);
    }))));
  }
}, Kt = class {
  constructor(t) {
    this._worker = t, this.canFormatMultipleRanges = !1;
  }
  provideDocumentRangeFormattingEdits(t, e, n, i) {
    const r = t.uri;
    return this._worker(r).then(((o) => o.format(r.toString(), vt(e), kt(n)).then(((s) => {
      if (s && s.length !== 0) return s.map(N);
    }))));
  }
};
function kt(t) {
  return { tabSize: t.tabSize, insertSpaces: t.insertSpaces };
}
var zt = class {
  constructor(t) {
    this._worker = t;
  }
  provideDocumentColors(t, e) {
    const n = t.uri;
    return this._worker(n).then(((i) => i.findDocumentColors(n.toString()))).then(((i) => {
      if (i) return i.map(((r) => ({ color: r.color, range: _(r.range) })));
    }));
  }
  provideColorPresentations(t, e, n) {
    const i = t.uri;
    return this._worker(i).then(((r) => r.getColorPresentations(i.toString(), e.color, vt(e.range)))).then(((r) => {
      if (r) return r.map(((o) => {
        let s = { label: o.label };
        return o.textEdit && (s.textEdit = N(o.textEdit)), o.additionalTextEdits && (s.additionalTextEdits = o.additionalTextEdits.map(N)), s;
      }));
    }));
  }
}, Xt = class {
  constructor(t) {
    this._worker = t;
  }
  provideFoldingRanges(t, e, n) {
    const i = t.uri;
    return this._worker(i).then(((r) => r.getFoldingRanges(i.toString(), e))).then(((r) => {
      if (r) return r.map(((o) => {
        const s = { start: o.startLine + 1, end: o.endLine + 1 };
        return o.kind !== void 0 && (s.kind = (function(c) {
          switch (c) {
            case M.Comment:
              return u.languages.FoldingRangeKind.Comment;
            case M.Imports:
              return u.languages.FoldingRangeKind.Imports;
            case M.Region:
              return u.languages.FoldingRangeKind.Region;
          }
        })(o.kind)), s;
      }));
    }));
  }
}, Bt = class {
  constructor(t) {
    this._worker = t;
  }
  provideSelectionRanges(t, e, n) {
    const i = t.uri;
    return this._worker(i).then(((r) => r.getSelectionRanges(i.toString(), e.map(I)))).then(((r) => {
      if (r) return r.map(((o) => {
        const s = [];
        for (; o; ) s.push({ range: _(o.range) }), o = o.parent;
        return s;
      }));
    }));
  }
};
function Qt(t) {
  const e = [], n = [], i = new St(t);
  e.push(i);
  const r = (...o) => i.getLanguageServiceWorker(...o);
  return (function() {
    const { languageId: o, modeConfiguration: s } = t;
    yt(n), s.completionItems && n.push(u.languages.registerCompletionItemProvider(o, new Mt(r, ["/", "-", ":"]))), s.hovers && n.push(u.languages.registerHoverProvider(o, new Ft(r))), s.documentHighlights && n.push(u.languages.registerDocumentHighlightProvider(o, new jt(r))), s.definitions && n.push(u.languages.registerDefinitionProvider(o, new Nt(r))), s.references && n.push(u.languages.registerReferenceProvider(o, new Ut(r))), s.documentSymbols && n.push(u.languages.registerDocumentSymbolProvider(o, new Vt(r))), s.rename && n.push(u.languages.registerRenameProvider(o, new Wt(r))), s.colors && n.push(u.languages.registerColorProvider(o, new zt(r))), s.foldingRanges && n.push(u.languages.registerFoldingRangeProvider(o, new Xt(r))), s.diagnostics && n.push(new Tt(o, r, t.onDidChange)), s.selectionRanges && n.push(u.languages.registerSelectionRangeProvider(o, new Bt(r))), s.documentFormattingEdits && n.push(u.languages.registerDocumentFormattingEditProvider(o, new Ht(r))), s.documentRangeFormattingEdits && n.push(u.languages.registerDocumentRangeFormattingEditProvider(o, new Kt(r)));
  })(), e.push(mt(n)), mt(e);
}
function mt(t) {
  return { dispose: () => yt(t) };
}
function yt(t) {
  for (; t.length; ) t.pop().dispose();
}
export {
  Mt as CompletionAdapter,
  Nt as DefinitionAdapter,
  Tt as DiagnosticsAdapter,
  zt as DocumentColorAdapter,
  Ht as DocumentFormattingEditProvider,
  jt as DocumentHighlightAdapter,
  qt as DocumentLinkAdapter,
  Kt as DocumentRangeFormattingEditProvider,
  Vt as DocumentSymbolAdapter,
  Xt as FoldingRangeAdapter,
  Ft as HoverAdapter,
  Ut as ReferenceAdapter,
  Wt as RenameAdapter,
  Bt as SelectionRangeAdapter,
  St as WorkerManager,
  I as fromPosition,
  vt as fromRange,
  Qt as setupMode,
  _ as toRange,
  N as toTextEdit
};
